export const getters = {
    currentCount(state) {
        return state.counter;
    },
    currentClientId(state) {
        return state.clientId;
    },
    currentCompanyId(state) {
        return state.companyId;
    },
    currentDirtyPageValidation(state) {
        return state.dirtyPageValidation;
    },
    currentIsSelectable(state) {
        return state.isSelectable;
    },
    currentSelectedAudienceID(state) {
        return state.selectedAudienceID;
    },
    currentEnvironment(state) {
        return state.environmentName;
    }
};
//# sourceMappingURL=getters.js.map